import axios from 'axios';

// Plain axios — no auth token needed for public endpoints
const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

export async function getLandingStats(): Promise<{
  happy_guests: number;
  properties: number;
  cities: number;
  average_rating: number;
}> {
  const response = await publicClient.get('/api/hosts/stats/');
  return response.data;
}

export async function submitPublicTicket(data: {
  property_id: string;
  room_number: string;
  message: string;
}): Promise<void> {
  await publicClient.post('/api/pg_tenant/public/tickets/', data);
}

export async function submitPublicRating(data: {
  property_id: string;
  room_number: string;
  cleaning_rating: number;
  internet_rating: number;
  food_rating: number;
  feedback_text?: string;
}): Promise<void> {
  await publicClient.post('/api/pg_tenant/public/ratings/', data);
}

export async function submitGuestReview(data: {
  property: string;
  guest_id: string;
  rating: number;
  comment?: string;
}): Promise<void> {
  await publicClient.post('/api/hosts/property-reviews/', data);
}

export interface IPropertyReview {
  id: number;
  guest_id: string;
  guest_name?: string;
  property: string;
  rating: number;
  comment: string;
}

export async function getPropertyReviews(propertyId: string): Promise<IPropertyReview[]> {
  console.log('[getPropertyReviews] calling for property:', propertyId);
  const response = await publicClient.get('/api/hosts/property-reviews/', {
    params: { property: propertyId },
  });
  console.log('[getPropertyReviews] raw response:', response.data);
  return response.data;
}
